module.exports = __webpack_public_path__ + "img/撞球.a891d00d.jpg";